import {FunctionComponent} from 'react';
import {css} from 'aphrodite/no-important';
import styles from './styles';

export const Spinner: FunctionComponent = () => {
    return <div className={css(styles.loader)}></div>;
};
